const BaseLayer = require("./baselayer");
const DefaultRenderer = require("./renderers/defaultrenderer");

/**
 * @typedef {Object} DataLayerOptions options for the DataLayer.
 * @property {woosmap.style.Styler} styler
 * @property {StoreEventCallback} click
 */

/**
 * @since 1.1.0
 * @extends woosmap.layers.BaseLayer
 * @memberOf woosmap.layers
 */
class DataLayer extends BaseLayer {
    _default_renderer(options) {
        return new DefaultRenderer(options);
    }

    /**
     * Displays on the map the stores passed as parameter.
     * @param {Array.<Store>} stores the stores to display.
     */
    displayStores(stores) {
        this._renderer.displayStores(stores);
    }

    /**
     * Displays the stores with numbered icons.
     * @param {Array.<Store>}stores the stores sorted by distance.
     */
    displayNumberedStores(stores) {
        this._renderer.displayNumberedStores(stores);
    }
}

module.exports = DataLayer;
